export default __webpack_public_path__ + "static/media/icons8-hand-with-smartphone-100.1855b35d.svg";